import { render, staticRenderFns } from "./TabBarItem.vue?vue&type=template&id=b3b6dfd6&scoped=true"
import script from "./TabBarItem.vue?vue&type=script&lang=js"
export * from "./TabBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b6dfd6",
  null
  
)

export default component.exports